import React from "react";
import Notification from "./notification";

const NotificationsDropdown = () => (
  <li className="nav-item dropdown no-arrow mx-1">
    <a
      className="nav-link dropdown-toggle"
      href="/#"
      id="alertsDropdown"
      role="button"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
    >
      <i className="fas fa-bell fa-fw"></i>
      <span className="badge badge-danger badge-counter">3+</span>
    </a>

    <div
      className="dropdown-list dropdown-menu dropdown-menu-right shadow animated--grow-in"
      aria-labelledby="alertsDropdown"
    >
      <h6 className="dropdown-header">Notificaciones</h6>
      <Notification
        details={{
          date: "December 12, 2019",
          icon: "fas fa-file-alt",
          body: "A new monthly report is ready to download!",
          read: false,
        }}
      />
      <Notification
        details={{
          date: "December 7, 2019",
          icon: "fas fa-donate",
          body: "$290.29 has been deposited into your account!",
          read: false,
        }}
      />
      <Notification
        details={{
          date: "December 2, 2019",
          icon: "fas fa-exclamation-triangle",
          body: "Spending Alert: We've noticed unusually high spending for your account.",
          read: true,
        }}
      />
      <a className="dropdown-item text-center small font-weight-bold" href="/#">
        MOSTRAR TODAS LAS NOTIFICACIONES
      </a>
    </div>
  </li>
);

export default NotificationsDropdown;
